<main class="o-layout__wrapper">
  <div class="c-promo u-pattern-star">
    <div class="c-promo__content">
      <img src="assets/img/visuals/visual-404.png" alt="" />
      <h3 i18n="Page not found|Title for page not found @@pageNotFoundTitle">
        Sorry!
      </h3>
      <p>
        <span
          i18n="Page not found|sentence1 for page not found @@pageNotFoundText1"
          >Looks like we can't find the page you're looking for.</span
        >
        <br />
        <span
          i18n="Page not found|sentence2 for page not found @@pageNotFoundText2"
          >Please head back to your dashboard.</span
        >
      </p>
      <a routerLink="/dashboard" class="o-button o-button--default">
        <i class="fa fa-home" aria-hidden="true"></i>
        <span
          i18n="Page not found|Link to go back to dashboard @@navigationDashboard"
          >Dashboard</span
        >
      </a>
    </div>
  </div>
</main>
